import clsx from 'clsx'

import type { ActionFooterProps } from './type'

import { Footer } from '@/components/layout/Footer'
import { MaxWidthLayout } from '@/components/layout/MaxWidthLayout'

export const ActionFooter = ({ inputRef, children }: ActionFooterProps) => {
  return (
    <Footer inputRef={inputRef}>
      <div className={clsx('tw-py-4', 'tw-bg-white')}>
        <MaxWidthLayout>
          <div className={clsx('tw-px-2 lg:tw-px-0')}>{children}</div>
        </MaxWidthLayout>
      </div>
    </Footer>
  )
}
